import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGifts } from '@fortawesome/free-solid-svg-icons';
import './TVBookShelfList.css';

// import {
//   ChildFruitsImage, ChildColorsImage, ChildNumbersEngImage, ChildAlphabetImage, ChildShapesSizesImage, ChildBirdsImage,
//   ChildVegetableImage, ChildFlowersImage, ChildWorldAroundUsImage, ChildKnowYourBodyImage, ChildFarmPetAnimalsImage,
//   ChildUnderwaterAnimalsImage, ChildMySchoolImage, ChildJobsPeopleDoImage, ChildWildAnimalsImage, ChildThingsAtHomeImage,
//   ChildFeelingsEmotionsMannersImage, ChildFirstWordsImage, ChildVehiclesImage, ChildFruitSet2Image, ChildPlantImage,
//   ChildHinduGodImage, ChildTreesImage, ChildFoodImage, ChildOppositeImage, NoImageImage
// } from '../learning/ImageImports';

const TVBookShelf = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [myBooks, setMyBooks] = useState([]);
  const [fetchData] = useFetch();

  const fetchMyBooks = useCallback(() => {
    const config = {
      url: "/mybooks/tv",
      method: "get",
      headers: { Authorization: authState.token },
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        if (response && Array.isArray(response.mybooks)) {
          setMyBooks(response.mybooks);
        } else {
          console.error("Invalid response format: Book not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching MyBooks:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchMyBooks();
  }, [authState.isLoggedIn, fetchMyBooks]);

  // const imageMap = {
  //   ChildFruitsImage, ChildColorsImage, ChildNumbersEngImage, ChildAlphabetImage, ChildShapesSizesImage, ChildBirdsImage,
  //   ChildVegetableImage, ChildFlowersImage, ChildWorldAroundUsImage, ChildKnowYourBodyImage, ChildFarmPetAnimalsImage,
  //   ChildUnderwaterAnimalsImage, ChildMySchoolImage, ChildJobsPeopleDoImage, ChildWildAnimalsImage, ChildThingsAtHomeImage,
  //   ChildFeelingsEmotionsMannersImage, ChildFirstWordsImage, ChildVehiclesImage, ChildFruitSet2Image, ChildPlantImage,
  //   ChildHinduGodImage, ChildTreesImage, ChildFoodImage, ChildOppositeImage, NoImageImage
  // };

  const getImage = (bookImage) => imageMap[bookImage] || NoImageImage;

  const handleReadClick = (bookCode, bookMasterId, bookCollectionName, lastPageRead, bookPages, bookIsChildren) => {
    navigate('/readtvbook', {
      state: {
        bookId: bookCode,
        bookMasterId: bookMasterId,
        bookCollectionName,
        lastPageRead,
        bookPages,
        isChildren: bookIsChildren
      }
    });
  };

  const sortedBooks = myBooks.sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate));

  return (
    <div className="tv-bookshelf-container">
      {myBooks.length === 0 ? (
        <div className="empty-bookshelf">
          <p>{authState.user.name}'s TVBookshelf is Empty!!</p>
        </div>
      ) : (
        <div className="book-grid">
          {sortedBooks.map((book, index) => (
            <div key={book.bookCode} className="book-item">
              <div className="book-index">{index + 1}</div>
              <div className="book-image-container">
                <button onClick={() => handleReadClick(
                  book.bookCode,
                  book.bookId,
                  book.bookCollectionName,
                  book.lastPageRead,
                  book.bookPages,
                  book.isChildren
                )}>
                  {/* <img
                    src={getImage(book.bookImage)}
                    alt={`No Image ${book.bookTitle}`}
                    className="book-image"
                  /> */}
                  {book.bookTitle}
                </button>
              </div>
              <div className="book-item">
                <div className="book-info flex flex-col">
                  <p className='text-blue-700'>{book?.bookTitle?.split('-').slice(1).join('-').trim() || ''}</p>
                  <p className="book-details text-sm">
                    Pages: {book.bookPages}
                  </p>
                  <p className="book-details text-sm">
                    Owned since: {new Date(book.purchaseDate).toLocaleDateString()}
                  </p>
                  {book.isGifted === 1 && (
                    <div className="gifted-info">
                      <FontAwesomeIcon icon={faGifts} className="gift-icon" />
                      <p>Gifted By: {book.gifterName}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TVBookShelf;
